import React from 'react';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';

const cn = createCn('file', classes);

type Props = {
  editing: boolean;
  saving?: boolean;
  disabled?: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
};

const MeetingSectionEditToolbar = ({
  editing,
  saving = false,
  disabled = false,
  onEdit,
  onSave,
  onCancel,
}: Props) => (
  <div className={cn('section-edit-toolbar')}>
    {!editing ? (
      <button
        type="button"
        className={cn('section-edit-btn')}
        onClick={onEdit}
        disabled={disabled}
      >
        Редактировать
      </button>
    ) : (
      <>
        <button
          type="button"
          className={cn('section-edit-btn', { primary: true })}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? 'Сохранение…' : 'Сохранить'}
        </button>
        <button
          type="button"
          className={cn('section-edit-btn', { secondary: true })}
          onClick={onCancel}
          disabled={saving}
        >
          Отмена
        </button>
      </>
    )}
  </div>
);

export default MeetingSectionEditToolbar;
